<app-side-dialog [disableClose]="true" (closeDialog)="onCloseClick()">
  <div dialogHeader>
    <h2>{{ 'pages.settings.userManagement.selectRoleDialog.title' | translate }}</h2>
  </div>

  <div dialogContent class="flex flex-col">
    <div class="flex flex-col gap-2">
      @for (role of data.roles; track role.id) {
        @let roleAssignable = isRoleAssignable(role);

        <!-- Tooltip goes on this wrapping span, not the button itself - a disabled button doesn't
             reliably fire the hover events MatTooltip needs. -->
        <span
          class="block w-full"
          matTooltipPosition="above"
          [matTooltip]="roleAssignable ? '' : cannotAssignRoleMessage"
          [matTooltipDisabled]="roleAssignable"
        >
          <button
            type="button"
            class="w-full flex items-center justify-between gap-3 rounded-full border border-shikenso-purple-base-12 p-1 pr-2 text-left"
            [class.hover:bg-shikenso-pink-base-12]="roleAssignable"
            [class.bg-shikenso-pink-base-40]="selectedRoleId() === role.id"
            [class.opacity-40]="!roleAssignable"
            [disabled]="submitLoading() || !roleAssignable"
            (click)="onRoleClick(role)"
          >
            <div class="flex items-center gap-3 min-w-0">
              <app-icon-badge
                color="var(--shikenso-purple-base)"
                backgroundColor="var(--shikenso-pink-100-40)"
                [content]="getRoleIcon(role)"
                [size]="40"
                [iconSize]="24"
                [borderRadius]="100"
                alt=""
              />
              <span class="text-sm">{{ getRoleName(role) }}</span>
            </div>

            @if (selectedRoleId() === role.id) {
              <app-icon src="/icons/circle-check.svg" [size]="20" color="var(--shikenso-pink-base)" alt="Selected" />
            }
          </button>
        </span>
      }
    </div>

    <button
      type="button"
      *hasPermission="EPermissions.roleCreate"
      class="w-full flex items-center justify-center gap-2 rounded-full border border-shikenso-purple-base-12 px-4 py-3 mt-4"
      [disabled]="submitLoading()"
      (click)="onAddCustomRoleClick()"
    >
      <app-icon src="/icons/plus.svg" [size]="16" alt="" />
      <span class="text-sm">{{ 'pages.settings.userManagement.selectRoleDialog.addCustomRole' | translate }}</span>
    </button>

    <div class="flex justify-end gap-3 mt-6">
      <button mat-button [disabled]="submitLoading()" (click)="onCloseClick()">
        {{ 'shared.cancel' | translate }}
      </button>
      <button mat-flat-button color="primary" [disabled]="submitLoading()" (click)="onSaveClick()">
        <p [class.hidden]="submitLoading()">{{ 'shared.save' | translate }}</p>

        @if (submitLoading()) {
          <app-dots-spinner />
        }
      </button>
    </div>
  </div>
</app-side-dialog>
